import type { NormalizedOrderData } from './getNormalizedOrderDataDiff';
import { getNormalizedOrderDataDiff } from './getNormalizedOrderDataDiff';
import { normalizeComparablePayload } from './normalizeComparablePayload';

/**
 * Returns true if there are pre-trade-relevant differences between a form
 * request payload and a scenario NewOrderSingle.
 */
export function hasPreTradeRelevantChanges(formPayload: unknown, scenarioNOS: unknown): boolean {
  const formData = normalizeComparablePayload(formPayload) as NormalizedOrderData;
  const nosData = normalizeComparablePayload(scenarioNOS) as NormalizedOrderData;
  return getNormalizedOrderDataDiff(formData, nosData).length > 0;
}
